var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAmazon = function SvgAmazon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "29A4BF4B-E2D7-4DC5-98E3-4005540991C7@0.5x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-100.000000, -1341.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "amazon-svgrepo-com",
    transform: "translate(100.000000, 1341.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF9900",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 0.9375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6875,11.6875 C13.8125,11.8125 10.125,12.875 10.125,16.75 C10.125,19.4375 11.75,20.75 13.9375,20.75 C15.875,20.75 17.125,20 18.1875,18.875 C18.6875,19.5625 18.8125,19.875 19.6875,20.5625 C19.875,20.6875 20.1875,20.6875 20.3125,20.5 L22.25,18.8125 C22.5,18.625 22.375,18.3125 22.25,18.1875 C21.8125,17.5 21.3125,17 21.3125,15.75 L21.3125,11.75 C21.3125,10.0625 21.4375,8.5 20.1875,7.375 C19.125,6.375 17.8125,6.125 16.3125,6.0625 C13,6 10.8125,7.8125 10.5,9.9375 C10.4375,10.3125 10.75,10.5 10.9375,10.5 L13.25,10.8125 C13.625,10.875 13.8125,10.5625 13.875,10.3125 C14.25,8.9375 15.6875,8.5625 16.5625,8.875 C17.8125,9.25 17.6875,10.6875 17.6875,11.6875 Z M15.4375,18.25 C14.5,18.25 13.875,17.4375 13.875,16.375 C13.9375,14.125 15.6875,13.75 17.6875,13.75 L17.6875,14.875 C17.6875,16.875 16.625,18.25 15.4375,18.25 Z M25.9375,24.875 C26.75,24.1875 27.5625,22.5 27.5,21.3125 C27.5,20.875 27.4375,20.8125 27,20.6875 C26.1875,20.4375 24.125,20.375 23.125,21.3125 C22.9375,21.5 23,21.625 23.1875,21.625 C23.875,21.5 26,21.25 26.3125,21.75 C26.5625,22.1875 25.8125,23.9375 25.5625,24.6875 C25.4375,25 25.6875,25.0625 25.9375,24.875 Z M3.625,21.375 C9.625,27.0625 19.0625,27.25 25.1875,22.9375 C25.625,22.6875 25.1875,22.1875 24.8125,22.375 C18.0144827,25.2498061 10.2607867,24.7637535 3.875,21.0625 C3.625,20.875 3.375,21.1875 3.625,21.375 L3.625,21.375 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAmazon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/amazon.b6c5bfcb.svg";
export { ForwardRef as ReactComponent };